module.exports = __webpack_public_path__ + "static/media/Inter-UI-Bold.8506a8d0.woff2";